import React, { Component } from 'react'
import { Modal, Table, Button } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';

export default class DownloadWord extends Component {
    state = {
        visible: false,
        data: [],
    }

    show = () => {
        this.setState({ visible: true },this.loadData);
    }
    loadData = () => {
        const options = {
            url: API_URL.contract.queryContractGuideFileMate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                (res.contractGuideFileMates || []).forEach( (el, index) => {
                    el.indexNum = index + 1;
                })
                this.setState({data:res.contractGuideFileMates})
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }  
    
    handleCancel = () => {
        this.setState({
            visible: false,
            data: [],
        });
    }

    download = fileMetaId => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'indexNum',
            key: 'indexNum',
            width: 60,
        }, {
            title: '适应角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 100,
        }, {
            title: '附件名称',
            dataIndex: 'name',
            key: 'name',
            width: 240,
            render: (text, record) => {
                const { fileMateId } = record;
                return <a onClick={ () => this.download(fileMateId) }>{text}</a>
            }
        }]
        return columns
    }


    render() {
        const { visible, data } = this.state;
        return (
            <Modal
                title="文档下载"
                visible={visible}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width={500}
                footer={ <Button onClick={this.handleCancel}>关闭</Button> }
            >
                <div className='downloadword'>
                    <p className='tip'>注：此处下载的是项目关闭流程文档</p>   
                    <Table
                        pagination={false}
                        dataSource={data}
                        columns={this.getColumns()}
                    />  
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/DownloadWord.js